<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">

    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{title}} Table</h3>
            <button class="btn btn-success" (click)="initModal('create')">Create</button>
          </div>

          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>APP ID</th>
                  <th>APP VERSION</th>
                  <th>DEVICE TYPE</th>
                  <th>force Update</th>
                  <th class="w-1">UPDATED AT</th>
                  <th class="w-1">ACT.</th>
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let app of appList">
                  <td>
                    <span>{{ app.appId }}</span>
                  </td>
                  <td>
                    <span>{{ app.appVersion }}</span>
                  </td>
                  <td>
                    <span>{{ app.deviceType }}</span>
                  </td>
                  <td>
                    <span>{{ app.forceUpdate }}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ app.updatedAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                  <td>
                    <button (click)="initModal('edit', app)" class="btn btn-default">
                      <i class="fa fa-edit" aria-hidden="true"></i>
                    </button>
                    <button (click)="deleteApp(app.id)" class="btn btn-danger">
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="appList?.length === 0">
                  <td class="text-center" colspan="8">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="appList?.length !== 0">
                  <td colspan="8">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + appList?.length }}
                    of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>


            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>

  </section>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content" *ngIf="app">
      <form (ngSubmit)="onSubmit(formapp)" #formapp="ngForm">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title"> {{ modal.title }}</h4>
        </div>
        <div class="modal-body">
          <input type="text" class="form-control hidden" name="id" [(ngModel)]="app.id">
          <div class="form-group">
            <label>AppId:</label>
            <input type="text" class="form-control" name="appId" [(ngModel)]="app.appId" #txtAppId="ngModel" required>
            <span *ngIf="txtAppId.errors?.required  && txtAppId.dirty" class="text text-danger">App Id is required.
            </span>
          </div>
          <div class="form-group">
            <label>App Version:</label>
            <input type="text" class="form-control" name="appVersion" [(ngModel)]="app.appVersion" #txtAppVersion="ngModel" required>
            <span *ngIf="txtAppVersion.errors?.required  && txtAppVersion.dirty" class="text text-danger">App version is required.
            </span>
          </div>
          <div class="form-group">
            <label>Device Type:</label>
            <select class="form-control" name="deviceType" [(ngModel)]="app.deviceType" #txtDeviceType="ngModel" required>
              <option value="">--Device type--</option>
              <option value="IOS">IOS</option>
              <option value="ADR">ANDROID</option>
              <option value="WEB">WEB</option>
              <option value="BRD">BRD</option>
            </select>
            <span *ngIf="txtDeviceType.errors?.required  && txtDeviceType.dirty" class="text text-danger">Device type is required.
            </span>
          </div>
          <div class="form-group">
            <label>Force Update:</label>
            <div class="radio">
              <label>
                <input type="radio" [value]="true" name="forceUpdate" ngModel [(ngModel)]="app.forceUpdate" required>True</label>
              <label>
                <input type="radio" [value]="false" name="forceUpdate" ngModel [(ngModel)]="app.forceUpdate" required>False</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" [disabled]="formapp.invalid" class="btn btn-primary">{{ modal.btnName }}</button>
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </form>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/version/version.component.html